import client from './client';

export const tagsApi = {
  // List tags for a project
  async list(params = {}) {
    const { data } = await client.get('/api/tags', { params });
    return data;
  },

  // Get single tag by ID
  async get(id) {
    const { data } = await client.get(`/api/tags/${id}`);
    return data;
  },

  // Create new tag
  async create(tag) {
    const { data } = await client.post('/api/tags', tag);
    return data;
  },

  // Update tag
  async update(id, updates) {
    const { data } = await client.patch(`/api/tags/${id}`, updates);
    return data;
  },

  // Delete tag
  async delete(id) {
    const { data } = await client.delete(`/api/tags/${id}`);
    return data;
  },

  // Copy tags from one project to another
  async copy(sourceProject, targetProject) {
    const { data } = await client.post('/api/tags/copy', {
      sourceProject,
      targetProject,
    });
    return data;
  },
};
